<template>
  <div
    :class="['back-to-top bounce', { active: isTop }]"
    @click="scrollToTop()"
  >
    <i class="ri-arrow-up-s-line"></i>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "BackToTop",
  data() {
    return {
      isTop: false,
    };
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
  mounted() {
    window.addEventListener("scroll", () => {
      let scrollPos = window.scrollY;
      if (scrollPos >= 100) {
        this.isTop = true;
      } else {
        this.isTop = false;
      }
    });
  },
});
</script>

<style lang="scss">
.back-to-top {
  font-size: 24px;
  width: 45px;
  height: 45px;
  line-height: 42px;
  text-align: center;
  position: fixed;
  bottom: 230px;
  opacity: 0;
  right: 20px;
  z-index: 999;
  border-radius: 5px;
  background: var(--clr_redical);
  box-shadow: 0 5px 5px rgba(0, 0, 0, 0.2);
  transition: 0.4s;
  cursor: pointer;

  &.active {
    bottom: 30px;
    opacity: 1;
  }

  i {
    color: var(--clr_white);
  }
}
</style>